import { useEffect, useRef, useState } from 'react'

function toString(value: number | null, fractionDigits?: number): string {
    if (value === null) { return '' }
    if (fractionDigits === undefined) { return value.toString() }
    return value.toFixed(fractionDigits)
}

export function useNumberInput<T extends number | null>(
    value: T,
    change: (value: T) => void,
    fractionDigits?: number,
    allowNull: boolean = false
) {
    const [last, setLast] = useState('')
    const internalValue = useRef<number | null>(null)

    useEffect(() => {
        // Only sync from props if it's an external change
        if (internalValue.current !== value) {
            setLast(toString(value, fractionDigits))
        }
        internalValue.current = null
    }, [value, fractionDigits])

    function onChange(input: string) {
        setLast(input)
        if (allowNull && input === '') {
            internalValue.current = null
            change(null as T)
            return
        }
        const v = parseFloat(input)
        if (!isNaN(v) && isFinite(v)) {
            internalValue.current = v
            change(v as T)
        }
    }

    function onBlur() {
        // revert to last valid value
        setLast(toString(value, fractionDigits))
    }

    return { last, onChange, onBlur }
}
